import React, { FC, useEffect } from "react";
import * as NavigationActions from '../../../actions/navigation';
import { RestrictedLayout } from "../../../components/layouts";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { GeneralSettingsBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import { SettingsGeneralSubMenu, SettingsSubMenu } from "../../../helpers/subMenuHelper";
import useDispatch, { useActionCreator } from "../../../hooks/useDispatch";
import useSelector from "../../../hooks/useSelector";
import SettingsCard from "../SettingsCard";

import './GeneralSettingsPage.scss';

const GeneralSettings: FC = () => {
    // Sidebar items
    const permissions = useSelector(state => state.user.userSummary?.permissions ?? []);
    const sideBarItems = SettingsSubMenu(permissions);
    
    // Breadcrumbs
    const breadcrumbs = GeneralSettingsBreadcrumbs();

    // Menu items
    const menuItems = SettingsGeneralSubMenu(permissions);

    const dispatch = useDispatch();
    const setDrawerItems = useActionCreator(NavigationActions.SetDrawerItems, dispatch);
    const setBreadcrumbs = useActionCreator(NavigationActions.SetBreadcrumbs, dispatch);


    useEffect(() => {
        setDrawerItems(sideBarItems);
        setBreadcrumbs(breadcrumbs);
    }, [setDrawerItems, setBreadcrumbs]);

    const renderGeneralSettingsCards = () => {
        return menuItems?.filter(x => x.description)?.map((item, index) => (
            <SettingsCard 
                key={`item-${item.title}-${index}`}
                navItem={item}
            />
        ));
    }

    return (
        <RestrictedLayout
            permission={Dtos.Permission.GeneralSettingsView}
        >
            <div className="settings-page">
                <div className="settings-container">
                    <h1 className="mb-4">General</h1>
                    <div className="settings-grid">
                        {renderGeneralSettingsCards()}
                    </div>
                </div>
            </div>
        </RestrictedLayout>
    );
}

export default GeneralSettings;